import { render, staticRenderFns } from "./Z-6_ColorTypography.vue?vue&type=template&id=73c01dac&"
import script from "./Z-6_ColorTypography.vue?vue&type=script&lang=js&"
export * from "./Z-6_ColorTypography.vue?vue&type=script&lang=js&"
import style0 from "./Z-6_ColorTypography.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
